import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { type BiLogger } from '../../components/Provider/BiLogger/BiLogger';
import { type GetInitialPaymentData } from '../../types/ExternalContract';
import { type OrderItem } from '../../types/OrderItem';
import { amountToLong } from '../../utils/amountToLong';
import { paymentMethodSelected } from '../../utils/bi/events/applePay';
import { transformPaymentBreakdownToApplePay } from './applePayDataMapper';

export const paymentMethodSelectedHandler =
  (
    cb: GetInitialPaymentData,
    data: {
      paymentLabel: string;
      appInstanceId: string;
      currencyCode: string;
      orderItems?: OrderItem[]; // TODO: remove this after ECOM integration
    },
    biLogger: BiLogger,
  ) =>
  async (event: ApplePayJS.ApplePayPaymentMethodSelectedEvent) => {
    try {
      const { paymentAmount, paymentBreakdown, orderItems } = await cb();
      const newTotal = { label: data.paymentLabel, amount: paymentAmount };
      const newLineItems = transformPaymentBreakdownToApplePay(paymentBreakdown, orderItems || data.orderItems);

      biLogger.report(paymentMethodSelected, {
        checkoutType: 'express',
        amount: amountToLong(newTotal.amount),
        currency: data.currencyCode,
        networkType: event.paymentMethod.network || event.paymentMethod.displayName,
        paymentMethodType: event.paymentMethod.type,
        paymentProvider: PaymentProvider.WixPayUS,
        paymentmethod: PaymentMethod.ApplePay,
        isPartner: undefined as any, // TODO[bi]
        pageType: undefined as any, // TODO[bi]
        orderSnapshotId: undefined as any, // TODO[bi]
        transactionId: undefined as any, // TODO[bi]
      });

      return {
        newTotal,
        newLineItems,
      };
    } catch (e) {
      return e;
    }
  };
